import PolicyLayout, { Section, P, Ul } from '../components/PolicyLayout';

export default function RefundPolicy() {
  return (
    <PolicyLayout art="refund" title="Refund policy" description="Find the cancellation conditions, refund process and timelines for your care services." updated="January 1, 2025">
        <Section title="1. Overview">
          <P>
            At NephroCore, we strive to provide a seamless and reliable health service experience. We understand that circumstances change, and this Refund Policy outlines when and how refunds are processed for our various services.
          </P>
          <P>
            All refunds are processed back to the original payment method within 5–7 business days after approval.
          </P>
        </Section>

        <Section title="2. Lab Test Bookings">
          <P><strong style={{ color: 'var(--dark)' }}>Full Refund (100%):</strong></P>
          <Ul items={[
            'Cancellation made more than 8 hours before the scheduled sample collection time',
            'Lab partner cancels or fails to collect the sample',
            'Test is unavailable at the selected lab',
            'Technical error resulting in duplicate booking',
          ]} />
          <P>Direct cancellation closes 8 hours before the scheduled sample collection time (IST). After that deadline, contact the care team for assistance; the booking cannot be cancelled directly in the app or website.</P>
          <P><strong style={{ color: 'var(--dark)' }}>No Refund:</strong></P>
          <Ul items={[
            'Sample has already been collected',
            'Test report has been delivered',
            'No-show without prior cancellation',
          ]} />
        </Section>

        <Section title="3. Doctor Consultations">
          <P><strong style={{ color: 'var(--dark)' }}>Full Refund (100%):</strong></P>
          <Ul items={[
            'Doctor cancels or does not attend the appointment',
            'Technical issues on our platform prevent the consultation',
            'Cancellation made more than 4 hours before the appointment',
          ]} />
          <P><strong style={{ color: 'var(--dark)' }}>Partial Refund (50%):</strong></P>
          <Ul items={[
            'Cancellation made within 4 hours of the appointment',
            'Consultation lasts less than 5 minutes due to technical difficulties',
          ]} />
          <P><strong style={{ color: 'var(--dark)' }}>No Refund:</strong></P>
          <Ul items={[
            'Consultation has been completed',
            'No-show without prior cancellation',
            'Cancellation made after the appointment time has passed',
          ]} />
        </Section>

        <Section title="4. Membership Plans">
          <P><strong style={{ color: 'var(--dark)' }}>Full Refund (100%):</strong></P>
          <Ul items={[
            'Request within 24 hours of purchase and no membership benefits have been used',
          ]} />
          <P><strong style={{ color: 'var(--dark)' }}>Pro-rated Refund:</strong></P>
          <Ul items={[
            'Request made within 7 days of purchase — refund calculated for unused days minus benefits already availed',
          ]} />
          <P><strong style={{ color: 'var(--dark)' }}>No Refund:</strong></P>
          <Ul items={[
            'More than 7 days have passed since purchase',
            'Membership has been fully or substantially used',
            'Promotional or discounted memberships',
          ]} />
        </Section>

        <Section title="5. Profile Verification Fee">
          <P>
            The one-time profile verification fee is non-refundable once the verification process has been initiated, regardless of the outcome. This fee covers the cost of identity verification and manual review by our team.
          </P>
        </Section>

        <Section title="6. Rewards & Coins">
          <P>
            NephroCore coins and rewards earned or purchased are non-refundable once redeemed against services or products. Unused purchased coins may be refunded within 7 days of purchase if no coins have been redeemed.
          </P>
        </Section>

        <Section title="7. How to Request a Refund">
          <P>To initiate a refund, please contact us with the following information:</P>
          <Ul items={[
            'Your registered email address or phone number',
            'Booking/transaction ID',
            'Reason for cancellation or refund request',
            'Date of the original transaction',
          ]} />
          <div className="nc-policy-note">
            <p style={{ fontWeight: 700, color: 'var(--dark)', marginBottom: 4 }}>Contact for Refunds</p>
            <a href="mailto:support@nephrocorenexus.com" style={{ color: 'var(--primary)', fontWeight: 600 }}>support@nephrocorenexus.com</a>
            <p style={{ color: 'var(--muted)', fontSize: '.9rem', marginTop: 4 }}>Mon–Sat, 10:00 AM – 6:00 PM IST</p>
          </div>
        </Section>

        <Section title="8. Refund Timeline">
          <P>
            Once a refund is approved, it will be processed to your original payment method within <strong style={{ color: 'var(--dark)' }}>5–7 business days</strong>. UPI refunds may be faster (1–2 days). For credit/debit cards, the refund may appear on your next statement depending on your bank.
          </P>
        </Section>

        <Section title="9. Disputes">
          <P>
            If you believe a refund was incorrectly denied, you may escalate the issue by emailing us with "REFUND DISPUTE" in the subject line. We will review and respond within 5 business days.
          </P>
        </Section>

        <Section title="10. Changes to This Policy">
          <P>
            We reserve the right to modify this Refund Policy at any time. Changes will be communicated via email or in-app notification and will apply to transactions made after the effective date.
          </P>
        </Section>
    </PolicyLayout>
  );
}
